var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['layout-index', {'layout-index_mobile': _vm.isMobile}]},[(_vm.isMobile)?_c('TopNavMobile'):_c('TopNav'),_vm._v(" "),_c('div',{staticClass:"layout-index_container"},[_c('Nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }